module.exports = __webpack_public_path__ + "assets/img/003-1.039c546c.jpg";